import getAll from './getAll'

function getToken (token) {
  return getAll()[token]
}

export default getToken
